const welcome = {
    title: 'Chào mừng đến với Admin Console',
    description: 'Admin console là một ứng dụng web để quản lý sdvico mà không cần viết code. Hãy bắt đầu bằng việc tạo một tài khoản. Với tài khoản này, bạn có thể tự quản lý sdvico hoặc quản lý thay mặt công ty của bạn.',
    create_account: 'Tạo tài khoản',
};
export default Object.freeze(welcome);
